import * as React from 'react';
import { Provider } from 'react-redux';
import { createFormStore } from 'sos-eservice-common/js/Redux/store.provider';
import { QualityRegisterOrderProps } from './QualityOrder.types';
import QualityRegisterOrderForm from './QualityRegisterOrderForm';
import { qualityregisterOrderStepValidationMap } from './qualityRegisterOrderStepValidationMap';
import {getInitialState} from './init';
import {setFormConfig} from 'sos-eservice-common/js/config';
import {QualityRegConfig} from './qualityRegOrderConfig';

export class QualityRegisterOrder extends React.Component<
  QualityRegisterOrderProps,
  any
> {

  private store: ReturnType<typeof createFormStore>;

  constructor(props) {
    super(props);
    const {basePath, translations} = this.props;
    setFormConfig(new QualityRegConfig(translations, basePath, qualityregisterOrderStepValidationMap));
    const initialState = getInitialState(this.props);
    this.store = createFormStore(initialState);
  }
  render() {
    return (
      <Provider
        store={this.store}
      >
        <QualityRegisterOrderForm />
      </Provider>
    );
  }
}
